import { useState } from 'react'
import { Button } from '@/common/ui/button'
import { Icons } from '@/common/ui/icons'
import useQueryWithdrawTransactionsById from '@/modules/transaction/api/hooks/useQueryWithdrawTransactionsById'
import PaymentGatewayErrorsModal from '../../PaymentGatewayErrorsModal'

interface WithdrawErrorLogsButtonProps {
	id: string
	errorCount: number
}

export default function WithdrawErrorLogsButton({
	id,
	errorCount,
}: WithdrawErrorLogsButtonProps) {
	const [open, setOpen] = useState(false)
	const { data: withdraw, isLoading } = useQueryWithdrawTransactionsById(id, {
		enabled: open,
	})

	if (errorCount === 0) {
		return <span>-</span>
	}

	return (
		<>
			<Button
				variant="destructive"
				size="sm"
				className="font-medium shadow-sm"
				onClick={() => setOpen(true)}
			>
				{isLoading && open ? (
					<Icons.spinner className="h-4 w-4 animate-spin" />
				) : (
					<>
						<Icons.warning className="h-4 w-4" />
						สาเหตุ
					</>
				)}
			</Button>
			{withdraw && (
				<PaymentGatewayErrorsModal
					open={open}
					onOpenChange={setOpen}
					errors={withdraw.paymentGatewayErrors || []}
					transactionId={id}
				/>
			)}
		</>
	)
}
